import axios from "axios";
import { getAuthorizationToken } from "../config/user";
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function addSurveyQuestions(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-default-survey-question`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function getSurveyQuestions(status, searchKey) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/survey-questions?status=${status}&searchKey=${searchKey}`,
  });
}
function updateSurveyQuestionStatus(id, status) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-survey-question-status?id=${Number(id)}`,
    data: { status: status },
    headers: getAuthorizationToken(),
  });
}
function saveSurveyDetails(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/submit-survey-detail`,
    data: data,
  });
}
function getSurveyDetails(page, limit, searchKey) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/get-survey-detail?page=${page}&limit=${limit}&searchKey=${searchKey}`,
    headers: getAuthorizationToken(),
  });
}

function getSurveyQuestionsReport() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/survey-input-report`,
    headers: getAuthorizationToken(),
  });
}
function updateQuestionSequence(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/survey-question-sequence-update`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function updateDeleteUserRequest(id, data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/update-delete-user-request?id=${id}`,
    data,
  });
}

function getDeleteUserRequest(id) {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/get-delete-user-request?id=${id}`,
  });
}


export const SurveyServices = {
  getSurveyQuestions,
  saveSurveyDetails,
  getSurveyDetails,
  addSurveyQuestions,
  updateSurveyQuestionStatus,
  getSurveyQuestionsReport,
  updateQuestionSequence,
  updateDeleteUserRequest,
  getDeleteUserRequest,
};
